function collapseDropdown(dropdown) {
    dropdown.classList.remove('active');
    dropdown.querySelector('[data-dropdown="options-list"]').style.maxHeight = null;
}

const dropdownList = document.querySelectorAll('[data-ui-el="dropdown"]');

[...dropdownList].forEach((dropdown) => {
    const dropdownButtons = dropdown.querySelector('[data-dropdown="btn"]');
    const optionsList = dropdown.querySelector('[data-dropdown="options-list"]');
    let isActive = false;

    dropdownButtons.addEventListener('click', () => {
        isActive = dropdown.classList.toggle('active');
        optionsList.style.maxHeight = isActive ? `${optionsList.scrollHeight}px` : null;
    });
});

if (dropdownList.length) {
    window.addEventListener('click', (event) => {
        const target = event.target.closest('[data-ui-el="dropdown"]');
        const activeDropdowns = [...dropdownList].filter(item => item.classList.contains('active') && item !== target);
        activeDropdowns.forEach(item => collapseDropdown(item));
    });
}
